import type {SxProps, Theme} from '@mui/material';

import {accent, text} from '../../../../../layouts/theme/designSystem';

/** Filled selection chip — design system chip-filled (accent.subtle + primary.text) */
export const workforceDepartmentChipSx: SxProps<Theme> = {
  height: 22,
  fontSize: 11,
  fontWeight: 500,
  bgcolor: accent.subtle,
  color: text.primary,
};
